import { getData } from "../helpers";
import { ProjectModal } from "../views/settings/settings/projects/modals/store";

class ButtonProject extends HTMLButtonElement {
    connectedCallback() {
        this.test();
        this.load();
        this.events();
    }

    test() {
        // No borrar este método, pero sí su contenido
    }

    load() {
        //
    }

    events() {
        this.addEventListener("click", (e) => {
            ProjectModal.create(
                getData(this, "data-bs-target"),
                getData(this, "title"),
                getData(this, "data-url"),
                getData(this, "data-message")
            );
        });
    }
}

window.customElements.define("button-project", ButtonProject, {
    extends: "button",
});
